import {
  IInboundInvoice,
  IInboundInvoiceWaitingApprovalListItem,
} from 'commons/types';

import { SwipeRxWmsApi } from '../resources';
import { SwipeRxAPIResources } from '../resources/types';

import {
  IGetInvoiceByInvoiceNumberRequest,
  IGetInvoiceByInvoiceNumberResponse,
  InboundInvoiceCompleteApprovalRequest,
  PostCreateInboundInvoiceRequest,
  PostUpdateInboundInvoiceRequest,
} from './type';

class SwipeRxWmsApiInboundInvoice extends SwipeRxWmsApi {
  private readonly basePath: string;

  constructor() {
    super(SwipeRxAPIResources.INBOUND_INVOICE);
    this.basePath = `/${this.apiResource}`;
  }

  async getInProgressInboundInvoice(): Promise<IInboundInvoice | null> {
    try {
      const response = await this.get(`${this.basePath}/in-progress`);
      return response.data;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async getWaitingApprovalInboundInvoice(
    params: IGetInvoiceByInvoiceNumberRequest,
  ): Promise<IGetInvoiceByInvoiceNumberResponse> {
    try {
      const response = await this.get(
        `${this.basePath}/waiting-approval`,
        params,
      );
      return response.data;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async getWaitingApprovalInvoiceList(): Promise<
    IInboundInvoiceWaitingApprovalListItem[]
  > {
    try {
      const response = await this.get(`${this.basePath}/waiting-approval-list`);
      return response.data;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async createInboundInvoice(
    payload: PostCreateInboundInvoiceRequest,
  ): Promise<IInboundInvoice> {
    try {
      const response = await this.post(`${this.basePath}/start`, payload);
      return response.data;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async updateInboundInvoice(
    payload: PostUpdateInboundInvoiceRequest,
  ): Promise<IInboundInvoice> {
    try {
      const response = await this.patch(`${this.basePath}/update`, payload);
      return response.data;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async postConfirmInvoice(): Promise<void> {
    await this.post(`${this.basePath}/confirm`, {});
  }

  async postCompleteApproval(
    params: InboundInvoiceCompleteApprovalRequest,
  ): Promise<void> {
    try {
      await this.post(`${this.basePath}/complete`, params);
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }
}

export const swipeRxWmsApiInboundInvoice = new SwipeRxWmsApiInboundInvoice();
